export const isArs = (name) => {
    if (name && name.includes('-ars')) {
        return true;
    }

    return (['Auto', 'Home', 'Combo', 'GrandProtect', 'PELP'].indexOf(name) > -1);
};
